import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MerchantLayout from "src/components/Layouts/MerchantLayout";
import Tables from "src/components/Table/tableData";
import {
  Select,
  FormControl,
  Stack,
  MenuItem,
  IconButton,
} from "@mui/material";
import { SesiKasirData, getSesiKasir } from "src/redux/sesiKasir";
import useRedux from "src/redux/useRedux";
import { NormalText } from "src/components/styled/text.styled";
import { ListStoreData, getAllStore } from "src/redux/storelist";
import ReportIcon from "src/assets/icons/report.svg";
import { toast } from "react-toastify";

const BannerPage = () => {
  const navigate = useNavigate();
  const {
    thunkDispatch,
    storeState: {
      Auth: {
        data: { user_type },
      },
      AppOption: { selected_store },
    },
  } = useRedux();
  const [data, setData] = useState<SesiKasirData[]>([]);
  // 1. KEMBALIKAN state dataFirst untuk menyimpan data asli
  const [dataFirst, setDataFirst] = useState<SesiKasirData[]>([]);
  const [listStore, setListStore] = useState<ListStoreData[]>([]);
  const [offset, setOffset] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [storeId, setStoreId] = useState("");
  const [totalData, setTotalData] = useState(0);

  const columns = [
    {
      name: "Nama Kasir",
      selector: (row: any) => row.cashier_name,
      sortable: true,
      center: true,
    },
    {
      name: "Waktu Buka Kasir",
      cell: (row: any) => row.start_time.split(" ")[1] ?? "-",
      sortable: true,
      center: true,
    },
    {
      name: "Kode Sesi",
      cell: (row: any) => row.session_code,
      sortable: true,
      center: true,
    },
    {
      name: "Aksi",
      cell: (row: any) => (
        <IconButton
          onClick={() => {
            if (row.store_name) {
              navigate("/report/order", {
                state: { store_name: row.store_name },
              });
            } else {
              console.error("store_name is undefined, navigation aborted");
              toast.error("No store name available for this row.");
            }
          }}
          title="Laporan Order"
        >
          <img
            src={ReportIcon}
            alt="Report"
            style={{ width: 24, height: 24 }}
          />
        </IconButton>
      ),
      sortable: true,
      center: true,
    },
  ];

  const getAll = () => {
    setLoading(true);
    let dataObject = {
      offset: offset - 1,
      limit: limit,
      store_id: storeId ? storeId : null,
    };
    thunkDispatch(getSesiKasir(dataObject))
      .unwrap()
      .then((res) => {
        if (res?.status == "success") {
          const responseData = res.data?.data || [];
          setData(responseData);
          setDataFirst(responseData);
          setTotalData(res.data?.meta?.total || 0);
        }
      })
      .catch((err) => {
        console.error("Error fetching SesiKasir data:", err);
        setData([]);
        setDataFirst([]);
        setTotalData(0);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSearch = (searchValue: string) => {
    setFilter(searchValue);
    if (searchValue.trim() === "") {
      setData(dataFirst);
    } else {
      const lowerSearch = searchValue.toLowerCase();
      const filtered = dataFirst.filter((item: any) =>
        Object.values(item).some(
          (val) =>
            typeof val === "string" && val.toLowerCase().includes(lowerSearch)
        )
      );
      setData(filtered);
    }
  };
  
  useEffect(() => {
    if (user_type && user_type === "merchant") {
      thunkDispatch(getAllStore({ offset: 0, limit: 0 }))
        .unwrap()
        .then((res) => {
          if (res?.status === "success") {
            setListStore(res.data.data);
          }
        });
    }
  }, [user_type]);

  useEffect(() => {
    getAll();
  }, [limit, offset, storeId]);

  const Filter = (val: any) => {
    setStoreId(val);
    setOffset(1);
  };

  return (
    <MerchantLayout>
      <Tables
        records={data}
        columns={columns}
        title="Sesi Kasir"
        isSearch={true}
        addButton={false}
        titleAdd=""
        onChangeSearch={(e) => handleSearch(e.target.value)}
        valueSearch={filter}
        handleAddButton={() =>
          navigate("/informasi/banner/add-banner", {
            state: { data: null, statusUrl: "add" },
          })
        }
        progressPending={loading}
        paginationPerPage={limit}
        totalRow={totalData}
        onChangePage={(page) => setOffset(page)}
        onChangeRowsPerPage={(currentRowsPerPage) => {
          setLimit(currentRowsPerPage);
          setOffset(1);
        }}
        filter={
          user_type && user_type === "merchant" ? (
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <NormalText textAlign="start" fontSize={"16px"}>
                Filter
              </NormalText>
              <FormControl sx={{ minWidth: 250 }}>
                <Select
                  value={storeId}
                  onChange={(e) => Filter(e.target.value)}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{ height: 40 }}
                >
                  <MenuItem value="">
                    <em>Pilih Toko</em>
                  </MenuItem>
                  {listStore &&
                    listStore.length !== 0 &&
                    listStore.map((value, index) => {
                      return (
                        <MenuItem key={index} value={value.id}>{value.store_name}</MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Stack>
          ) : undefined
        }
      />
    </MerchantLayout>
  );
};

export default BannerPage;
